import { createApp, App as VueAppType } from 'vue'
import { pinia } from '@/store'
import router from '@/router'
import acl from '@teams/common/acl'
import App from './App.vue'
import i18n from './i18n'
import { apmPlugin } from './utils/apm'
import microApp from '@micro-zoe/micro-app'
import { idle, yieldToMain } from '@/utils'
import {
  // create naive ui
  create,
  // component
  NButton,
  NSpace,
  NLayout,
  NLayoutHeader,
  NLayoutSider,
  NLayoutContent,
  NLayoutFooter,
  NScrollbar,
  NIcon,
  NInput,
  NInputGroup,
  NGrid,
  NGridItem,
  NPopover,
  NTooltip,
  NSlider
} from 'naive-ui'

import './styles/base.less'

import { modifyComponentsPropsCommon } from '@teams/common/hooks/useModifyComponentsProps'

function idleLoadSreComponents(app: VueAppType<Element>) {
  idle(async () => {
    await yieldToMain({ times: 3 })
    const [elementPlusModule, sreCommonPlusModule] = await Promise.all([
      // ElementPlus
      import('element-plus'),
      // @sre/common-components-plus
      import('@sre/common-components-plus'),
      import('element-plus/dist/index.css'),
      import('@sre/common-components-plus/lib/common-components.css')
    ])
    await yieldToMain()
    const ElementPlus = elementPlusModule.default
    const { install } = sreCommonPlusModule
    app.use({
      install
    })
    app.use(ElementPlus)
  })
}

function loadNaiveUiComponents(app: VueAppType<Element>) {
  const naive = create({
    components: [
      NButton,
      NSpace,
      NLayout,
      NLayoutHeader,
      NLayoutSider,
      NLayoutContent,
      NLayoutFooter,
      NScrollbar,
      NIcon,
      NInput,
      NInputGroup,
      NGrid,
      NGridItem,
      NPopover,
      NTooltip,
      NSlider
    ]
  })
  app.use(naive)
}

// 全局修改组件默认配置
function modifyComponentsProps() {
  // 修改NTooltip组件为默认延时400ms
  NTooltip.props.delay = { type: Number, default: 400 }
}

document.domain = 'wps.cn'

modifyComponentsProps()
modifyComponentsPropsCommon()

const app = createApp(App)
idleLoadSreComponents(app)
loadNaiveUiComponents(app)
app.use(router).use(pinia).use(i18n)
app.use(acl)
app.use(apmPlugin)
app.mount('#app')
microApp.start()
